import SuccessScreen from './Success'

export default SuccessScreen
